import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Card, CardBody, Input, Button, Table, FormGroup, Label, UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import Select from 'react-select';
import queryString from 'query-string'
import moment from "moment";
import { toast } from 'react-toastify';
import { cloneDeep, filter, isEmpty, isNil, startsWith } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Pagination from '../../components/Pagination';
import RowLoading from '../../components/RowLoading';
import RowEmpty from '../../components/RowEmpty';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import noImage from '../../assets/images/users/no-img.jpg';
import PriceUtils from '../../helpers/PriceUtils';
import { connect } from 'react-redux';
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import NavTab from '../../components/NavTab';
import { baseUrl } from '../../constants/environment';
import styled from 'styled-components';
import TextUtils from '../../helpers/TextUtils';
import { MySelectLoading } from '../../helpers/SelectAsync';
import ToggleButton from '../../common/ToggleButton';
import UserManager from '../../manager/UserManager';
import { ReceiptsGroup } from '../receipts/ReceiptsList';

const configPage = {
    titlePage: 'Tạo loại thu chi',
    pathPage: '/setting/typereceipts',
    column: 10,
}

interface Props {
    history: any,
    location: any,
    match: any,
    user: any,
}
const initialParams = {
    page: 1,
    limit: 25,
    filter: {}
}

const TypereceiptsAdd = (props: any) => {
    const {from, user} = props
    const router = useHistory()
    const [loading, setLoading] = useState(false);
    const [id, setId] = useState();
    const [data, setData] = useState<any>({
        name:"",
        code:"",
        note:"",
        status: 1
    });
    const [modalIsOpen, setIsOpen] = useState(false);

    const { closeModal, action, onlyView } = props
    const type = action?.type

    useEffect(() => {
    }, []);

    useEffect(() => {
        if(action?.data?.id){
            loadData(action?.data?.id)
            setId(action?.data?.id)
        }
    }, [action?.data]);


    const loadData = async (id:number) => {
        const url = `${baseUrl}/receiptstype/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            setData(resData)
        }
    }

    const handleChangeInput = (event?: any) => {
        let { value, name } = event.target
        if (value === " ") return;
        if (name === "phone") {
            value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "")
        }
        if(value?.length > 1000) return;
        setData({
            ...data,
            [name]: value
        })
    }

    const validationFrom = () => {
        if (isEmpty(data.name)) {
            toast.warning('Tên loại không được để trống!');
            return false
        }
        if (isEmpty(data.type)) {
            toast.warning('Loại loại không được để trống!');
            return false
        }
        if (isEmpty(data.classify)) {
            toast.warning('Phân nhóm loại không được để trống!');
            return false
        }
        if (data.classify === 'other' && isEmpty(data.classify_name)) {
            toast.warning('Tên phân loại không được để trống!');
            return false
        }
        return true
    }
    
    const handleSubmit = async() => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/receiptstype`;
        const params = {
            name: data?.name,
            note: data?.note,
            status: 1,
            type: data?.type,
            classify: data?.classify,
            classify_name: data?.classify === 'other' ? data?.classify_name : undefined,
        }
        let response: any = await APIClient.POST(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Tạo mới loại thu chi thành công')
            props?.loadData()
            closeModal()
        }
    }

    const handleEdit = async() => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/receiptstype/${id}`;
        const params = {
            name: data?.name,
            note: data?.note,
            status: 1,
            type: data?.type,
            classify: data?.classify,
            classify_name: data?.classify === 'other' ? data?.classify_name : undefined,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Chỉnh sửa loại thu chi thành công')
            props?.loadData()
            closeModal()
        }
    }

    return (
        <CardBody className='p-0' style={{width: 600}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                {
                    action?.type === 'add' ? "Tạo loại phiếu thu chi" :
                    action?.type === 'view' ? "Chi tiết loại phiếu thu chi" :
                    action?.type === 'edit' ? "Chỉnh sửa loại phiếu thu chi"
                    : "Thông báo"
                }
                </h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body p-4">
                <PageContent className={onlyView ? 'only-view' : ''}>
                    <Row>
                        {/* <Col md={6} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label>Mã loại thu chi</Label>
                                <Input type="text" value={data?.code} onChange={(e: any) => handleChangeInput(e)} name="code" placeholder={(type == 'view' && !data?.code) ? "---" : "Nhập mã loại thu chi"} />
                            </FormGroup>
                        </Col> */}
                        <Col md={12} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label><span>*</span>Tên loại thu chi</Label>
                                <Input type="text" value={data?.name} onChange={(e: any) => handleChangeInput(e)} name="name" placeholder="Nhập tên loại thu chi" />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label><span>*</span> Loại</Label>
                                <div className="d-flex align-items-center">
                                    <Row style={{width:'100%'}}>
                                        <Col xl={6}>
                                            <div className={data?.type == 'receipts' ? "nutri-radio active" : "nutri-radio"} onClick={() => type=='view' ? {} :setData({...data, type:'receipts'}) }>
                                                <div className="icon"></div>
                                                <div className="label">Thu tiền</div>
                                            </div>
                                        </Col>
                                        <Col xl={6}>
                                            <div className={data?.type == 'payment' ? "nutri-radio active" : "nutri-radio"} onClick={() => type=='view' ? {} :setData({...data, type:'payment'})}>
                                                <div className="icon"></div>
                                                <div className="label">Chi tiền</div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </FormGroup>
                        </Col>
                        <Col md={6} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label><span>*</span>Phân nhóm thu chi</Label>
                                <Select
                                    placeholder="Chọn phân loại"
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    maxMenuHeight={250}
                                    isDisabled={onlyView}
                                    onChange={(val: any) => {
                                        setData({ ...data, classify: val?.value })
                                    }}
                                    value={ReceiptsGroup?.filter(
                                        (option: any) => data?.classify == option.value
                                    )}
                                    options={ReceiptsGroup}
                                ></Select>
                            </FormGroup>
                        </Col>
                        {data?.classify === 'other' &&
                            <Col md={12} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span>Tên phân loại</Label>
                                    <Input type="text" value={data?.classify_name} onChange={(e: any) => handleChangeInput(e)} name="classify_name" placeholder="Nhập tên phân loại" />
                                </FormGroup>
                            </Col>}
                    </Row>
                    <Row>
                        <Col md={12} xs={12}>
                            <FormGroup className='nutri-form'>
                                <Label>Nội dung</Label>
                                {
                                    type != 'view' ?
                                    <Input type="textarea" rows={1} value={data?.note} onChange={(e: any) => handleChangeInput(e)} name="note" placeholder={(type == 'view' && !data?.note) ? "---" : "Nhập nội dung"} /> :
                                    <div className="value-text">{data?.note}</div>
                                }
                            </FormGroup>
                        </Col>
                    </Row>
                    {
                        type == 'view' &&
                        <Row>
                            <Col md={4} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label><span>*</span>Trạng thái</Label>
                                    {
                                        type != 'view' ?
                                        <div style={{marginTop:10}}>
                                            <ToggleButton elmChecked={data?.status == 1 ? true : false} data={data} setData={(data:any) => setData(data)} name='status' />
                                        </div> :
                                        <ValueText className={data?.status == 1 ? 'text-success' : "text-danger"}>{data?.status == 1 ? 'Đang hoạt động' : "Ngưng hoạt động"}</ValueText>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md={4} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label>Người tạo</Label>
                                    <ValueText>{data?.created_uid?.name}</ValueText>
                                </FormGroup>
                            </Col>
                            <Col md={4} xs={12}>
                                <FormGroup className='nutri-form'>
                                    <Label>Ngày tạo</Label>
                                    <ValueText>{moment(data?.created_time).format("HH:mm:ss DD/MM/YYYY")}</ValueText>
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                </PageContent>
            </div>
            
            <div className="modal-footer">
                {action?.type === 'add' &&
                    <>
                        <Button
                            onClick={()=>{handleSubmit() }}
                            className="ml-2" color="success" type="button"
                        >Lưu</Button>
                    </>
                }
                {action?.type === 'edit' &&
                    <Button
                        onClick={()=>{handleEdit() }}
                        className="ml-2" color="success" type="button"
                    >Cập nhật</Button>
                }
            </div>
            {loading && <Loader />}
        </CardBody>
    );
};

const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
`

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`


export default connect(mapState)(TypereceiptsAdd)